<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.as_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="as_date">
            <label class="weui-form-preview__label">{{
              customLabel.as_date || "投诉日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.as_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_urgency">
            <label class="weui-form-preview__label">{{
              customLabel.as_urgency || "紧急程度"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.as_urgency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_custname">
            <label class="weui-form-preview__label">{{
              customLabel.as_custname || "客户名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.as_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_contact">
            <label class="weui-form-preview__label">{{
              customLabel.as_contact || "投诉人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.as_contact
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_tel">
            <label class="weui-form-preview__label">{{
              customLabel.as_tel || "联系电话"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.as_tel }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_classify">
            <label class="weui-form-preview__label">{{
              customLabel.as_classify || "售后类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.as_classify
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_way">
            <label class="weui-form-preview__label">{{
              customLabel.as_way || "售后来源"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.as_way }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.main.as_classify == '客户投诉' || form.main.as_classify == '其他'">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="as_content">
            <label class="weui-form-preview__label">{{
              customLabel.as_content || "详情内容"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.as_content
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_why">
            <label class="weui-form-preview__label">{{
              customLabel.as_why || "原因分析"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_why }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_short_policy">
            <label class="weui-form-preview__label">{{
              customLabel.as_short_policy || "临时对策"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_short_policy }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_improve">
            <label class="weui-form-preview__label">{{
              customLabel.as_improve || "改善对策"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_improve }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_effect">
            <label class="weui-form-preview__label">{{
              customLabel.as_effect || "效果验证"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_effect }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_long_policy">
            <label class="weui-form-preview__label">{{
              customLabel.as_long_policy || "防止再发生对策"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_long_policy }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_quality">
            <label class="weui-form-preview__label">{{
              customLabel.as_quality || "品质确认"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_quality }}
            </span>
          </div>
        </custom-layout>
      </div>
       <div class="form-preview weui-form-preview" v-if="form.main.as_classify == '产品维修' || form.main.as_classify == '售后退货'">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="as_prodcode">
            <label class="weui-form-preview__label">{{
              customLabel.as_prodcode || "产品编号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.as_prodcode
            }}</span>
          </div>
           <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{
              customLabel.pr_detail || "产品名称"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pr_detail }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pr_orispeccode }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec">
            <label class="weui-form-preview__label">{{
              customLabel.pr_spec || "产品规格"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.pr_spec }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_shelflife">
            <label class="weui-form-preview__label">{{
              customLabel.as_shelflife || "保质期"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_shelflife }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_qty">
            <label class="weui-form-preview__label">{{
              customLabel.as_qty || "数量"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_qty }}
            </span>
          </div>
           <div class="weui-form-preview__item" slot="as_salecode">
            <label class="weui-form-preview__label">{{
              customLabel.as_salecode || "销售订单"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_salecode }}
            </span>
          </div>
           <div class="weui-form-preview__item" slot="as_sn" v-if="form.main.as_classify == '产品维修'">
            <label class="weui-form-preview__label">{{
              customLabel.as_sn || "S/N"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_sn }}
            </span>
          </div>
           <div class="weui-form-preview__item" slot="as_batchcode" v-if="form.main.as_classify == '售后退货'">
            <label class="weui-form-preview__label">{{
              customLabel.as_batchcode || "批次号"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_batchcode }}
            </span>
          </div>
           <div class="weui-form-preview__item" slot="as_why" v-if="form.main.as_why">
            <label class="weui-form-preview__label">{{
              customLabel.as_why || "原因分析"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_why }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_describe" v-if="form.main.as_describe">
            <label class="weui-form-preview__label">{{
              customLabel.as_describe || "描述"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_describe }}
            </span>
          </div>
           <div class="weui-form-preview__item" slot="as_measure"  v-if="form.main.as_measure">
            <label class="weui-form-preview__label">{{
              customLabel.as_measure || "处理方法"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_measure }}
            </span>
          </div>
        </custom-layout>
      </div>


      <div class="form-preview weui-form-preview">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="creatorName" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">{{
              customLabel.creatorName || "录入人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="as_auditman" v-if="form.main.as_auditman">
            <label class="weui-form-preview__label">{{
              customLabel.as_auditman || "审核人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_auditman }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="as_dutyer" v-if="form.main.as_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.as_dutyer || "责任人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.as_dutyer }}
            </span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-show="form.main.as_attach">
        <div class="weui-panel__hd">附件</div>
        <div class="weui-form-preview__bd">
          <file-list v-model="form.main.as_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/crm/after_sale_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
       <a
        href="javascript:;"
        v-if="!editable && form.main.as_classify == '产品维修'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnin_after_sales"
        >转售后维修</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
       <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/sale/afterSale",
      codeField: "as_code",
      statusField: "as_status_code",
      caller: "AfterSale",
    };
  },
  methods:{
    turnin_after_sales() {
      var me = this;
       me.$router.push({
            name: "AfterSaleRepairEdit",
            params: {
              form:me.form
            }
          });
    },
  }
};
</script>